import React from 'react'
import CurrentQuizPage from '../Components/Page/StartQuiz/CurrentQuizPage'
interface props{
    userId:string
}
function HomeCurrentQuiz({userId}:props) {
  
  return (
    <div><CurrentQuizPage userId={userId}/></div>
  )
}

export default HomeCurrentQuiz